export const NOTIFICATION_PREFERENCES = {
    'sms': 1,
    'email': 2,
    'none': 3
}